document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-bn-menu-toggle]');
  if (!toggle) return;

  var targetId = toggle.getAttribute('aria-controls');
  var panel = document.getElementById(targetId);
  if (!panel) return;

  var expanded = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!expanded));
  panel.setAttribute('aria-hidden', String(expanded));
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;

  document.querySelectorAll('[data-bn-menu-toggle][aria-expanded="true"]').forEach(function (toggle) {
    var targetId = toggle.getAttribute('aria-controls');
    var panel = document.getElementById(targetId);

    toggle.setAttribute('aria-expanded', 'false');
    if (panel) panel.setAttribute('aria-hidden', 'true');
  });
});

document.addEventListener('submit', function (event) {
  var form = event.target.closest('[data-bn-product-form], .bn-product-form, .bn-product-card__form, .bn-sticky-atc form');
  if (!form) return;

  var button = form.querySelector('[type="submit"]');
  if (!button) return;

  button.setAttribute('aria-busy', 'true');
});
